import React from 'react'
import axios from 'axios'
import { Link, browserHistory } from 'react-router'
import '../../../css/page/CouponSPA.css'
import {renderMoney, isLZWKAPP, TimeStream, randomArr, isIos} from '../../../utils'
import {WKOwnDialog} from '../../../components/wk'

// 好像是抽奖的
class RowItem extends React.Component {

    renderImgClass () {
        switch (this.props.content.raw_name) {
            case 'notebook':
                return 'row__item-nb'
            case 'washmc':
                return 'row__item-mc'
            case '30rp':
            case '90rp':
                return 'row__item-rp'
            case '5rp':
                return 'row__item-ip'
            case 'prize_cl':
                return 'row__item-cl'
            case 'thanks01':
            case 'thanks02':
                return 'row__item-thx'
            default :
                return ''
                break
        }
    }

    render() {
        return (
            <div className={`${this.props.activedId === this.props.content.id ? 'row__item row__item-active' : 'row__item'}`} id={`row_item_${this.props.content.id}`}>
                <img src={this.props.content.img} alt="" className={this.renderImgClass()}/>
                {this.props.content.name}
            </div>
        )
    }
}




class DrawLottery extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            prizePlaying: false,
            prizeList: [
                {
                    raw_name: 'notebook',
                    name: '限量记事本',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_91e602979f21571a4f9b3e8bc18153b6.jpg',
                    id: 0
                },
                {
                    raw_name: 'washmc',
                    name: '扫地机器人',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_756b833a9bc4ff9e16857dc157935901.jpg',
                    id: 1
                },
                {
                    raw_name: '30rp',
                    name: '30元红包',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_61e90e24a4eb87fafd50a3856353de42.jpg',
                    id: 2
                },
                {
                    raw_name: 'prize_cl',
                    name: '定制马克杯',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_b75f14cfbe4145f84c0a78c0c0519ef3.jpg',
                    id: 3
                },
                {
                    raw_name: 'thanks01',
                    name: '谢谢参与',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_3c896fefc8fb2b8b5c601ec9475297c8.jpg',
                    id: 4
                },
                {
                    raw_name: '90rp',
                    name: '105元红包',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_61e90e24a4eb87fafd50a3856353de42.jpg',
                    id: 5
                },
                {
                    raw_name: '5rp',
                    name: 'iPhone X',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_b3d612be0d80e3b449f2495b53b0a907.jpg',
                    id: 6
                },
                {
                    raw_name: 'thanks02',
                    name: '继续加油',
                    img: 'https://static-1253442168.image.myqcloud.com/picture/5459246_3c896fefc8fb2b8b5c601ec9475297c8.jpg',
                    id: 7
                }
            ],
            prizeActivedId: '',
            prizePrizeId: null,
            prizeTimes: 0,
            prizeActTimes: 0,
            prizeCanShowChannel: false,
            prizeShareShown: false,
            prizeGetShown: false,
            prizeRemainCount: '',
            prizeLottery: '',
            prizeDialogText: '',
            prizeDialogShow: false,
            prizeHasCouplet: false
        }
    }

    mta (payload) {
        this.props.dispatch({ type: 'MTA_CLICK', payload });
    }

    componentDidMount(){
        const bagid = this.props.location.query.bagid
        this.fetchLuckydrawInfo(bagid)
    }


    fetchLuckydrawInfo (bagid) {
        let data = {}
        if (this.props.location.query.lucky_inviter_id) {
            data.lucky_inviter_id = this.props.location.query.lucky_inviter_id
        }
        axios.get(`/api/coupon/weike_active/${bagid}/luckydraw/init`, {
            params: data
        })
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        prizeRemainCount: res.data.data.remain_count,
                        prizeHasCouplet: res.data.data.has_couplet
                    })
                }
            })
    }

    handleBegin () {
        if (!this.state.prizePlaying) {
            this.setState({
                prizePlaying: true
            })
            this.mta('couponspa_click_begin_luckydraw')
            const bagid =this.props.location.query.bagid
            axios.post(`/api/coupon/weike_active/${bagid}/luckydraw/start`)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            prizeLottery: res.data.data.lottery,
                        })
                        axios.get(`/api/coupon/weike_active/${bagid}/luckydraw/init`)
                            .then(res => {
                                if (res.data.code === 0) {
                                    this.setState({
                                        prizeRemainCount: res.data.data.remain_count,
                                    }, () => {
                                        this.setState({
                                            prizeActivedId: '',
                                            prizePrizeId: null,
                                            prizeTimes: 0,
                                            prizeActTimes: 0
                                        }, () => {
                                            this.handlePlay()
                                        })
                                    })
                                }
                            })
                    } else {
                        this.setState({
                            prizeDialogShow: true,
                            prizeDialogText: res.data.msg
                        })
                    }
                })
        }
    }

    handlePlay() {
        let prize;
        switch (this.state.prizeLottery) {
            case 'couponbag':
                prize = 5
                break
            case 'thx':
                prize = Math.round(Math.random()) ? 4 : 7
                break
            case 'couplet':
                prize = 3
                break
            default:
                prize = Math.round(Math.random()) ? 4 : 7
                break
        }
        this.setState({
            prizePrizeId: prize,
            prizeActivedId: 0
        })
        let times = this.state.prizeList.length * Math.floor(Math.random() * 2 + 2)
        this.setState({
            prizeTimes: times
        })
        this.begin = setInterval(() => {
            let num;

            if (this.state.prizeActivedId === this.state.prizePrizeId && this.state.prizeActTimes > this.state.prizeTimes) {
                clearInterval(this.begin)
                if (this.state.prizePrizeId === 3) {
                    this.setState({
                        prizeGetShown: true
                    })
                }
                if (this.state.prizePrizeId === 5) {
                    if (!this.state.is_join) {
                        const bagid = this.props.location.query.bagid
                        this.props.fetchGetCouponAuto(bagid)
                    }
                    this.setState({
                        prizeCanShowChannel: true
                    })
                }
                this.setState({
                    prizePlaying: false
                })
                return
            }

            if (this.state.prizeActivedId === '') {
                num = 0
                this.setState({
                    prizeActivedId: num
                })
            } else {
                num = this.state.prizeActivedId
                if (num === 7) {
                    num = 0
                    this.setState({
                        prizeActivedId: num
                    })
                } else {
                    num = num + 1
                    this.setState({
                        prizeActivedId: num
                    })
                }
            }

            this.setState({
                prizeActTimes: this.state.prizeActTimes + 1
            })

        }, 100)
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            prizeCanShowChannel:nextProps.prizeCanShowChannel
        })
    }


    render(){
        const iosAppLzb = Number(this.props.location.query.bagid) === 13 && isIos() && isLZWKAPP()
        const {prizeList, prizeActivedId} = this.state
        return (
            <div>
                <WKOwnDialog title="温馨提示" show={this.state.prizeDialogShow} buttons={[
                {
                label: '知道了',
                onClick: () => {
                this.setState({
                prizeDialogShow: false
                })
                }
                }
                ]}>
                {this.state.prizeDialogText}
                </WKOwnDialog>

                {/*抽奖区域*/}
                <div className="couponspa__prize">
                    <div className="top__bg">
                    <img
                        src="https://static-1253442168.image.myqcloud.com/picture/5459246_6b29e32faae83b4395683db8f0b7ec3f.jpg"
                        alt=""/>
                </div>


                    {!this.state.prizeCanShowChannel &&
                    <div className="top__header">
                        <img src={require('../../../images/activity/couponspa/jxll_bz.png')}
                             alt=""/>
                    </div>
                    }



                    <div className="prize__num" style={{marginTop: this.state.prizeCanShowChannel ? '20px' : '0', marginBottom: this.state.prizeCanShowChannel ? '15px' : '20px'}}>
                        <div className="num__gift">
                            <img
                                src="https://static-1253442168.image.myqcloud.com/picture/5459246_b1da9535a2f22236627b4c63d52a96ad.jpg"
                                alt=""/>
                        </div>
                        <div className="num__text">
                            剩余抽奖：<span>{this.state.prizeRemainCount}</span>次
                        </div>
                    </div>

                    {this.state.prizeRemainCount === 0 && false &&
                    <p className="prize__tips">*用券购买课程可获得更多抽奖机会</p>
                    }

                    <div className="prize__area">
                        <div className="area__row">
                            <RowItem content={prizeList[0]} activedId={prizeActivedId} />
                            <RowItem content={prizeList[1]} activedId={prizeActivedId} />
                            <RowItem content={prizeList[2]} activedId={prizeActivedId} />
                        </div>
                        <div className="area__row">
                            <RowItem content={prizeList[7]} activedId={prizeActivedId} />
                            <div onClick={() => this.handleBegin()}
                                 className={this.state.prizeRemainCount === 0 ? 'row__item row__item-begin-no' : 'row__item row__item-begin'}>
                                <img
                                    src="https://static-1253442168.image.myqcloud.com/picture/5459246_772d64ea870ed2dfc5c84d355609db80.jpg"
                                    alt=""
                                    style={{margin: '0'}}
                                />
                            </div>
                            <RowItem content={prizeList[3]} activedId={prizeActivedId} />
                        </div>
                        <div className="area__row">
                            <RowItem content={prizeList[6]} activedId={prizeActivedId} />
                            <RowItem content={prizeList[5]} activedId={prizeActivedId} />
                            <RowItem content={prizeList[4]} activedId={prizeActivedId} />
                        </div>
                    </div>
                </div>

                {
                    //春联 弹出二维码
                    this.state.prizeHasCouplet && (
                        <div onClick={() => this.setState({prizeGetShown: true})}
                             className="more" style={{paddingTop: '15px'}}>
                            {'>> 查看获奖记录 <<'}
                        </div>
                    )
                }

                {!this.state.prizeCanShowChannel && isIos() && isLZWKAPP() &&
                <div className="more" style={{paddingTop: '40px'}}>
                    {'以上所有抽奖商品由荔枝微课独家提供'}
                </div>
                }

            </div>
        )
    }
}

export default DrawLottery


// WEBPACK FOOTER //
// ./src/components/activity/couponSPA/DrawLottery.js